/* globals gtag */
import React, { useCallback, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { SetShowFilters } from "../../state/actions/index"
import "./FiltersContainer.css"
import ActiveFilter from "../ActiveFilter/ActiveFilter"
import PerfectScrollbar from "react-perfect-scrollbar"
import FilterAccordion from "../FilterAccordion/FilterAccordion"
import {
  SetSliderValueMinMax,
  SetUrlPrefix,
  SetImgPrefix,
  SetSliderValue,
  SetIsSearching,
  SetIsExpanded,
  SetActiveFilters,
  SetPrevProducts,
  SetAsyncData,
  SetListingBanner,
  SetProducts,
  SetResultsCount,
  SetFilters,
  SetMasterCategories,
  SetPages,
  SetPage,
  SetSuggestedWords,
} from "../../state/actions/index"
import Utils from "../../utils/Utils"
import axios from "axios"

const FiltersContainer = (props) => {
  const filters = useSelector((state) => state.filters)
  const resultsCount = useSelector((state) => state.resultsCount)
  const nameProducts = useSelector(
    (state) => state.config.placeholders.products
  )
  const isMobile = useSelector((state) => state.isMobile)
  const filterBy = useSelector((state) => state.config.placeholders.filterBy)
  const showFilters = useSelector((state) => state.showFilters)
  const activeFilters = useSelector((state) => state.activeFilters)
  const display = useSelector((state) => state.config.display)
  const shopId = useSelector((state) => state.config.shopId)
  const card = useSelector((state) => state.config.card)
  const baseUrl = useSelector((state) => state.config.baseUrl)
  const searchWord = useSelector((state) => state.searchWord)
  const config = useSelector((state) => state.config)
  const sort = useSelector((state) => state.sort)
  const sliderValue = useSelector((state) => state.sliderValue)
  const sliderValueMinMax = useSelector((state) => state.sliderValueMinMax)
  const configFilters = useSelector((state) => state.config.filters)
  const clearFilters = useSelector(
    (state) => state.config.placeholders.clearFilters
  )
  const products = useSelector((state) => state.products)
  const defaultMasterCategories = useSelector(
    (state) => state.defaultMasterCategories
  )
  const ga4 = useSelector((state) => state.config.ga4)
  const dispatch = useDispatch()
  const { subCategory, setSubCategory } = props
  const accentColor = useSelector((state) => state.config.accentColor)
  var titleStyle = useMemo(() => {
    return { color: accentColor }
  }, [accentColor])
  var sortedFilters = useMemo(() => {
    return filters
      .filter((item) => configFilters[item.title])
      .sort((a, b) =>
        configFilters[a.title] && configFilters[b.title]
          ? configFilters[a.title].order - configFilters[b.title].order
          : -1
      )
  }, [filters, configFilters])

  const categoryKey = useMemo(() => {
    var valueToReturn = ""
    Object.keys(configFilters).forEach((filter) => {
      if (configFilters[filter].isCategory) valueToReturn = filter
    })
    return valueToReturn
  }, [configFilters])

  const queryOptions = useSelector((state) => state.config.queryOptions)
  var rows = useMemo(
    () => (isMobile ? queryOptions.rows.mobile : queryOptions.rows.desktop),
    [isMobile, queryOptions]
  )

  const hideFilters = useCallback(() => {
    Utils.sendAnalyticsObject(baseUrl, shopId, "as_close_filters")
    if (!!ga4?.isActive) {
      if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
        window.dataLayer.push({
          event: "as_close_filters",
          data: {},
        })
      } else if (typeof gtag !== "undefined") {
        gtag("event", "as_close_filters", {})
      }
    }
    dispatch(SetShowFilters(false))
  }, [dispatch, shopId, baseUrl])

  const removeAllFilters = useCallback(() => {
    dispatch(SetIsSearching(true))
    dispatch(SetAsyncData([]))
    var priceGroup = {}
    priceGroup.id =
      window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
        ? window.AS_ADVANCED_CONFIG.visitorType
        : config.priceGroup.id
    priceGroup.currency =
      window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
        ? window.AS_ADVANCED_CONFIG.currencyCode
        : config.priceGroup.currency
    var localSearchUrl = Utils.getSearchUrl(
      config.baseUrl,
      config.queryOptions,
      priceGroup,
      config.shopId,
      config.jsonFast
    )
    axios
      .get(
        Utils.insertWordInSearchUrl(
          localSearchUrl,
          searchWord,
          [],
          sort,
          1,
          configFilters,
          rows
        )
      )
      .then((res) => {
        var response = res.data
        dispatch(SetIsExpanded({}))
        dispatch(SetActiveFilters([]))
        dispatch(SetPrevProducts(products))
        dispatch(
          SetProducts(
            Utils.refactorUrl(
              response.data,
              response.header.imagePrefix,
              response.header.urlPrefix,
              card.img,
              card.url
            )
          )
        )
        dispatch(SetSuggestedWords(response.suggestions))
        dispatch(SetResultsCount(response.header.results_count))
        dispatch(SetSliderValue(Utils.addSliderValue(response, sliderValue)))
        dispatch(
          SetSliderValueMinMax(
            Utils.addSliderValue(response, sliderValueMinMax)
          )
        )
        dispatch(SetFilters(response))
        dispatch(
          SetPages(parseInt((response.header.results_count - 1) / rows) + 1)
        )
        dispatch(SetPage(1))
        dispatch(SetListingBanner(response.banners[0]))
        dispatch(
          SetMasterCategories(
            response.stats[categoryKey]
              ? Utils.refactorMasterCategories(
                  Object.keys(response.stats[categoryKey])
                )
              : defaultMasterCategories
          )
        )
        dispatch(SetUrlPrefix(response.header.urlPrefix))
        dispatch(SetImgPrefix(response.header.imagePrefix))
        dispatch(SetShowFilters(false))
        if (config.webhook.key !== "")
          Utils.getAsyncData(config.webhook, response.data, priceGroup).then(
            (value) => dispatch(SetAsyncData(value.asyncData))
          )
      })
      .finally(() => dispatch(SetIsSearching(false)))
  }, [
    dispatch,
    searchWord,
    defaultMasterCategories,
    sort,
    rows,
    sliderValue,
    sliderValueMinMax,
    config,
    configFilters,
    products,
    categoryKey,
    card,
  ])
  return (
    <div
      className={
        "filters-container " +
        (showFilters ? " show" : "") +
        (activeFilters.length > 0 ? " with-active-filters" : "")
      }
    >
      <div className="title-container">
        <div style={titleStyle} className="title">
          {" "}
          {filterBy}{" "}
        </div>
        {isMobile && activeFilters.length > 0 ? (
          <div className="rimuovi-filters" onClick={removeAllFilters}>
            {" "}
            {clearFilters}{" "}
          </div>
        ) : null}
        {isMobile || display !== "full-screen" ? (
          <div className="close" onClick={hideFilters}></div>
        ) : display === "full-screen" /*  && !isSearching */ ? (
          <div className="results-count">
            {" "}
            {resultsCount + " " + nameProducts}{" "}
          </div>
        ) : null}
      </div>
      {isMobile ? (
        <PerfectScrollbar className="active-filters">
          {activeFilters.map((el, index) => (
            <ActiveFilter
              value={el}
              key={"active_filter_" + index}
              defaultActiveKey={"active_filter_" + index}
            />
          ))}
        </PerfectScrollbar>
      ) : null}
      <PerfectScrollbar>
        {sortedFilters.map((el, index) => (
          <FilterAccordion
            value={el}
            key={"filter_" + index}
            defaultActiveKey={"filter_" + index}
            subCategory={subCategory}
            setSubCategory={setSubCategory}
          />
        ))}
      </PerfectScrollbar>
    </div>
  )
}
export default FiltersContainer
